import script from "./sf-multiselect.vue?vue&type=script&setup=true&lang=ts&generic=I%2C%20MV"
export * from "./sf-multiselect.vue?vue&type=script&setup=true&lang=ts&generic=I%2C%20MV"

import "./sf-multiselect.vue?vue&type=style&index=0&id=b74b9143&lang=scss"

const __exports__ = script;

export default __exports__